import {getUser} from 'src/modules/admin/services';
import {useAppSelector} from 'src/store';

import {LocalStorage} from '@pb/kit-util-client-storage';

export const useUserRoles = () => {
    return useAppSelector(getUser)?.roles || LocalStorage.get('user')?.roles || [];
};
